// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-option{position:relative}.radio-option .v-radio .v-input--selection-controls__input{align-self:flex-start}.checkbox-option,.radio-option audio{min-width:220px}.radio-option label{width:83%}.broadcast__counter-tag{position:absolute;right:0;top:0;padding:5px 10px;line-height:.9em;font-size:.9em}", ""]);
// Exports
module.exports = exports;
